// extracted by mini-css-extract-plugin
export var container = "_9q-0";
export var error = "_9q-9";
export var label = "_9q-5";
export var light = "_9q-6";
export var md = "_9q-3";
export var sm = "_9q-2";
export var thin = "_9q-8";
export var thinBold = "_9q-7";
export var vertical = "_9q-4";
export var xs = "_9q-1";